import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';

class MapHandlerAndIntent extends Component {

    constructor() {
        super();
        this.state = {
            sluValue: "",
            domainId: null,
            showLoader: false
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchMapHandlerAndIntentApi();
        }, 300);
    }

    fetchMapHandlerAndIntentApi = () => {
        var mapHandlerAndIntendController = this;
        mapHandlerAndIntendController.state.domainId = this.props.location.state.domainId
        $.ajax({
            url: "/api/slu-intent",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "domainId": mapHandlerAndIntendController.state.domainId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    mapHandlerAndIntendController.setState({ showLoader: true });
                    if (res.result.length !== 0) {
                        var domainOptionTag = document.getElementById("slu");
                        for (var i = 0; i < res["result"].length; i++) {
                            domainOptionTag.innerHTML = domainOptionTag.innerHTML + '<option value="' +
                                res["result"][i]["id"] + '">' + res["result"][i]["name"] + '</option>';
                        }
                        mapHandlerAndIntendController.state.sluValue = res["result"][0]["id"];
                    }
                } else {
                    mapHandlerAndIntendController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToCreate(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    saveMapToIntent = () => {
        let mapHandlerAndIntendController = this;
        var handlerType;
        if (this.props.location.state.previousCompPath == "dsm") {
            handlerType = "DST";
        } else {
            handlerType = "DWF";
        }
        let handlerId = mapHandlerAndIntendController.props.location.state.handlerId;
        let data = {
            intentId: this.state.sluValue,
            handlerId: handlerId,
            handlerType: handlerType,
            projectId: localStorage.getItem("currentProjectId"),
        }
        $.ajax({
            url: "/api/dsm-mapping",
            async: false,
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json"
            },
            data: JSON.stringify(data),
            success: function (res) {
                if (res.success === true) {
                    mapHandlerAndIntendController.notifyAddedSuccess();
                    var mapHandlerAndIntendInter = setInterval(function () {
                        clearTimeout(mapHandlerAndIntendInter);
                        mapHandlerAndIntendController.goBack();
                    }, 3000);
                }
                else {
                    mapHandlerAndIntendController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyAddedSuccess() {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Saved Successfully</b>, {
            position: "top-center",
        });
    }

    handleChange = (e) => {
        this.setState({ sluValue: e.target.value })
    }

    goBack = () => {
        if (this.props.location.state.previousCompPath == "dsm") {
            this.props.history.push({
                pathname: "/projectmgmt/nlutab/dsm",
                state: { goBackToDsm: true }
            });
        } else {
            this.props.history.push({
                pathname: "/projectmgmt/nlutab/dsm/dsm-graphs",
                state: { goBackToDsm: true }
            });
        }
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper">
                        <div className="content-wrapper" >
                            <div className="content-header">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-5"></div></div>
                                    <ToastContainer className="Toast-at-center" />

                                    <h6 className="taglineTxt">
                                        <img className="cursor-change" src="./assets/images/arrow.svg"
                                            onClick={this.goBack}
                                            style={{ width: '24px', marginTop: '20px' }} /></h6>
                                    <h1 className="m-0 page-title">Map Handler And Intent</h1><br /><br />

                                    <div className="d-flex">
                                        <h1 className="m-0 page-title">Intent : &nbsp;&nbsp;</h1>
                                        <select className="input-group mb-3 form-control select2"
                                            style={{ width: '40%', marginTop: '15px' }}
                                            value={this.state.sluValue}
                                            name="slu" id="slu" onChange={this.handleChange}>
                                        </select>
                                        <button
                                            className="btn action-button"
                                            style={{ marginLeft: "20px" }}
                                            onClick={this.saveMapToIntent}>Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }

}

export default MapHandlerAndIntent;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/MapHandlerAndIntent.js